import BaseModel from "../core/BaseModel";
export default class SampleLicenseModel extends BaseModel {
  constructor() {
    super(
      {
        name: "sample_license",
        tableName: "sample_license",
        label: "Danh sách giấy phép làm việc mẫu",
        display_key: "name",
        default_order: { key: "created_at", direction: "asc" },
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          type: "Computed",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: { 
            name: 'id', 
            type: "Uuid", 
            label: 'ID', 
            primaryKey: true,
            display: false
        },
        name: {
            name: 'name',
            type: "TEXT",
            label: 'Tên giấy phép',
            sortable: false,
            // width: 20,
            filter: {type: 'input',match: 'contains'}
        },
        count_total: {
          name: 'count_total',
          type: "INT", 
          label: 'SL tiêu chí',
          display: false,
        },
        total_criteria: {
          name: 'total_criteria',
          type: "CustomUrl", 
          label: 'SL tiêu chí',
          class: 'center',
          sortable: false,
          width: 8,
          computed: (data) => {
            data.total_criteria = 0;
          }
        },
        active : {
          name: 'active', 
          type: "Selection", 
          custom: 'SelectionText',
          label: 'Hiển thị',
          class: 'center',
          width: 6,
          options: [
            {label: "Hiển thị",value: true},
            {label: "Ẩn",value: false}
          ],
          filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
          display: false,
        },
        updated_name : {
          name: 'updated_name', 
          type: "TEXT", 
          label: 'Người cập nhật',
        },
        updated_at: {
          name: "updated_at",
          type: "Datetime",
          label: "Cập nhật cuối",
          // filter: { type: "DateRange", match: "contains" },
        },
        created_at: {
          name: "created_at",
          type: "Datetime",
          label: "Ngày tạo",
          filter: { type: "DateRange", match: "contains" },
          display: false,
        }
      }
    );
  }
}
